module.exports = __webpack_public_path__ + "static/img/5.b0d7221.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/5.png
// module id = 201
// module chunks = 1